import { SvgIcon, SvgIconProps } from '@mui/material';

export const TotalRefundIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.8781 8.69155C14.7351 8.27811 14.4738 7.91774 14.1279 7.65681C13.7821 7.39588 13.3675 7.24634 12.9375 7.22743H10.0625C9.49063 7.22743 8.94218 7.45881 8.5378 7.87068C8.13343 8.28254 7.90625 8.84115 7.90625 9.42361C7.90625 10.0061 8.13343 10.5647 8.5378 10.9765C8.94218 11.3884 9.49063 11.6198 10.0625 11.6198H12.9375C13.5094 11.6198 14.0578 11.8512 14.4622 12.263C14.8666 12.6749 15.0938 13.2335 15.0938 13.816C15.0938 14.3984 14.8666 14.957 14.4622 15.3689C14.0578 15.7808 13.5094 16.0122 12.9375 16.0122H10.0625C9.63251 15.9932 9.2179 15.8437 8.87206 15.5828C8.52621 15.3218 8.26494 14.9615 8.12188 14.548M11.5 5.03125V7.22743M11.5 16.0122V18.2083'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.8333 1H2.16667C1.52233 1 1 1.52233 1 2.16667V20.8333C1 21.4777 1.52233 22 2.16667 22H20.8333C21.4777 22 22 21.4777 22 20.8333V2.16667C22 1.52233 21.4777 1 20.8333 1Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
